export default "__VITE_ASSET__B$1tfU3r__"